import { render, staticRenderFns } from "./SignatureDraw.vue?vue&type=template&id=c2ca64a6"
import script from "./SignatureDraw.vue?vue&type=script&lang=js"
export * from "./SignatureDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports